/* globals EasyScroller */
(function () {
	'use strict';
	/**
	 * @ngdoc directive
	 * @name smb-app.directive:smbItemSelector
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * `smbItemSelector` is a hortizonal scrolling list of items
	 *
	 * @param {array=} items The items to show in scroller
	 *
	 * @param {bool} multiple The ability to select multiple items
	 *
	 * @usage
	 *
	 * <smb-item-selector items="['one', 'two']" multiple="true"/>
	 */

	angular.module('smb-app')
		.directive('smbItemSelector', ['$window','$timeout', ItemSelectorDirective])
		.controller('ItemSelectorController', [ItemSelectorController]);

	var templateUrl = require('./itemSelector.template');
	function ItemSelectorDirective($window, $timeout) {
		return {
			restrict: 'E',
			controller: [ItemSelectorController],
			controllerAs: 'vm',
			bindToController: {
				items: '=',
				multiple: '='
			},
			templateUrl: templateUrl,
			scope: true,
			link: function (scope, element) {
				
			}
		};
	}

	function ItemSelectorController() {
		var vm = this;
		vm.toggleSelection = function (item) {
			if (vm.isDragging) { return; }
			if (!vm.multiple) {
				vm.items = vm.items.map(function (i) {
					i.selected = false;
					return i;
				});
				item.selected = true;
				return;
			}

			item.selected = !item.selected;
		};
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/itemSelector/itemSelector.js
// module id = 92
// module chunks = 1